<template>
    <div class="bg-main">
        <TopBar :isShowToggle="false"></TopBar>
        <div class="container">
            <div class="row area-menu-home text-center">
                <div class="col-12">
                    <b-button
                        class="btn custom-btn"
                        @click="goto('registration')"
                        >New Registration</b-button
                    >
                </div>
                <div class="col-12">
                    <b-button
                        class="btn custom-btn"
                        @click="goto('supplementary')"
                        >Link Supplementary Card</b-button
                    >
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";

import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";

// load new component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import BottomBar from "@/components/Layout/BottomBar/BottomBar.vue";

export default {
    name: "home",
    components: {
        ModalMaster,
        TopBar,
        BottomBar
    },
    mixins: [LocaleMixin, ErrorApiMixin],
    data: function() {
        return {
            // all new modal
            modalController: null,
            alertModal: null,
            loadingModal: null,
            confirmModal: null
        };
    },
    created: function() {
        Account.loginStatus().then(status => {
            this.isLogin = status;
            if (status) {
                this.profile = Account.getCacheProfile();
            }
        });

        Vue.ga.screenName(this, "Home");
        Vue.ga.event(this, "new cat", "view page", "home label");

        // modal setup
        var modalFactory = new ModalFactory();
        this.modalController = modalFactory.getModalController();
        this.alertModal = modalFactory.getAlertModal();
        this.confirmModal = modalFactory.getConfirmModal();
        this.loadingModal = modalFactory.getLoadingModal();
    },
    methods: {
        goto: function(location) {
            switch (location) {
                case "registration":
                    this.$router.push("registration");
                    break;
                case "supplementary":
                    this.$router.push("supplementary");
                    break;
                default:
                    break;
            }
        },

        // all new modal
        clickShowAlert: function() {
            this.alertModal
                .clearText()
                .setTitle("This is title")
                .setMsg("modal message")
                .setBtnOk("Button ok")
                .setTag("alert-1")
                .show();
            this.alertModal.onClickOk(data => {
                console.log(data);
                console.log("alert ok");
            });
            this.alertModal.onHidden(data => {
                console.log(data);
                console.log("alert hidden");
            });
        },
        clickShowLoading: function() {
            this.loadingModal.show();
        },
        clickShowConfirm: function() {
            this.confirmModal
                .clearText()
                .setTitle("Header confirm")
                .setMsg("Message Confirm")
                .setBtnOk("YES")
                .setBtnCancel("NO")
                .setTag("test-confirm")
                .show();
            this.confirmModal.onClickOk(data => {
                console.log(data);
                console.log("click confirm");
            });
            this.confirmModal.onClickCancel(data => {
                console.log(data);
                console.log("click cancel");
            });
        }
    }
};
// import test from '../../../../public/img/'
</script>
<style lang="scss" scoped>
@import "Home.scss";

.div-flex {
    display: flex;
}
</style>
